import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.UploadChequeDocument.IRequest;
type Response = Api.Finance.AccountReceivable.UploadChequeDocument.IResponse;
type Headers = Api.Finance.AccountReceivable.UploadChequeDocument.IHeaders;
const url = '/api/Finance/AccountReceivable/:id/UploadChequeDocument';
export default async function accountReceivableUploadChequeDocumentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(url, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
